import React, { useState } from "react";

const InsertEmailSettings = () => {
  const [formData, setFormData] = useState({ action: "insert", username: "", domain_name: "", incoming_mail_server: "", imap_port: "", pop3_port: "", outgoing_mail_server: "", smtp_port: "", });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const requiredFields = [
      "username",
      "domain_name",
      "incoming_mail_server",
      "imap_port",
      "pop3_port",
      "outgoing_mail_server",
      "smtp_port",
    ];

    for (const field of requiredFields) {
      if (!formData[field]) {
        return `The field ${field} is required.`;
      }
    }

    if (!/^(\d+)$/.test(formData.imap_port) || !/^(\d+)$/.test(formData.pop3_port) || !/^(\d+)$/.test(formData.smtp_port)) {
      return "Ports must be numeric values.";
    }

    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      //index.php
      const response = await fetch("index.php",
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        }
      );

      console.log("Request Payload:", formData);

      const text = await response.text(); 
      console.log("Response Text:", text);

      const data = JSON.parse(text);

      if (response.ok && data.success) {
        console.log("Backend response:", data);
        setSuccess("Email settings inserted successfully!");
        setFormData({ username: "", domain_name: "", incoming_mail_server: "", imap_port: "", pop3_port: "", outgoing_mail_server: "", smtp_port: "", });
      } else {
        console.log("Backend response:", data);
        setError(data.message || "Failed to insert email settings.");
      }
    } catch (err) {
      console.error('Error while submitting domain:', err);
      setError("An error occurred while inserting email settings.");
    }
  };

  return (
    <div>
      <h1>Insert Email Settings</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}
      <form onSubmit={handleSubmit}>
        <label htmlFor="username">Username:</label><br />
        <input type="text" name="username" id="username" value={formData.username} onChange={handleChange} /><br />

        <label htmlFor="domain_name">Domain Name:</label><br />
        <input type="text" name="domain_name" id="domain_name" value={formData.domain_name} onChange={handleChange}/><br />

        <label htmlFor="incoming_mail_server">Incoming Server:</label><br />
        <input type="text" name="incoming_mail_server" id="incoming_mail_server" value={formData.incoming_mail_server} onChange={handleChange} /><br />

        <label htmlFor="imap_port">IMAP Port:</label><br />
        <input type="text" name="imap_port" id="imap_port" value={formData.imap_port} onChange={handleChange} /><br />

        <label htmlFor="pop3_port">POP3 Port:</label><br />
        <input type="text" name="pop3_port" id="pop3_port" value={formData.pop3_port} onChange={handleChange} /><br />

        <label htmlFor="outgoing_mail_server">Outgoing Server:</label><br />
        <input type="text" name="outgoing_mail_server" id="outgoing_mail_server" value={formData.outgoing_mail_server} onChange={handleChange} /><br />

        <label htmlFor="smtp_port">SMTP Port:</label><br />
        <input type="text" name="smtp_port" id="smtp_port" value={formData.smtp_port} onChange={handleChange} /><br />

        <button type="submit">Insert</button>
      </form>
    </div>
  );
};

export default InsertEmailSettings;
